import { startTransition, StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';
import { whenI18nReady } from '@/i18n-client-init';
import { registry } from '@/lib/registry';
import { initializeRegistry } from '@/lib/static-registry';

async function preloadCriticalPageDesignerComponents(): Promise<void> {
    initializeRegistry();
    const typeIds = new Set<string>();

    for (const marker of document.querySelectorAll('[data-page-designer-critical-components]')) {
        const value = marker.getAttribute('data-page-designer-critical-components');
        value?.split(/\s+/).forEach((typeId) => {
            if (typeId) typeIds.add(typeId);
        });
    }

    await Promise.allSettled([...typeIds].map((typeId) => registry.preloadEager(typeId)));
}

void Promise.all([whenI18nReady(), preloadCriticalPageDesignerComponents()]).then(() => {
    startTransition(() => {
        hydrateRoot(
            document,
            <StrictMode>
                <HydratedRouter />
            </StrictMode>
        );
    });
});
